export default {
  nickname: 'account-nickname',
  accountNumber: 'account-number',
  routingNumber: 'account-routing-number',
  accountType: 'account-type',
  accountClass: 'account-class',
};
